import {createStore} from 'vuex'
import com_modules from './com_modules/index'
// import lung_modules from '../components/lung/store/index'
// console.log(com_modules, 'com_modules');

export default createStore({
    state: {},
    getters: {},
    mutations: {},
    actions: {},
    modules: {
        ...com_modules,
    },
    strict: process.env.NODE_ENV !== "production"
})
